import React, {PropTypes} from 'react';

import BookItem from './BookItem';

const style = {
  bookList: {
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingBottom: "10px",
    overflow: "auto"
  },
  book: {
    marginLeft: "8px",
    marginRight: "8px",
    marginTop: "5px",
    marginBottom: "5px",
    float: "left"
  }
};

const bookImgSource = {
  book1: require('../bookCovers/book1.png'),
  book2: require('../bookCovers/book2.png'),
  book3: require('../bookCovers/book3.png')
};

const BookItems = ({items}) => {
  return (
    <div style={style.bookList}>
        {items.map(item =>
          <div style={style.book} key={item.coverImg}>
            <BookItem
              key={item.coverImg}
              item={item}
              img={bookImgSource[item.coverImg]}
            />
          </div>
        )}
    </div>
  );
};

BookItems.propTypes = {
  items: PropTypes.array
};


export default BookItems;



/** WEBPACK FOOTER **
 ** ./src/components/common/content-items/BookItems.js
 **/